"use client"
import { LocaleContext } from "@opensea/i18n"
import { useContext } from "react"

export const useLocale = () => {
  return useContext(LocaleContext)
}
